import React, { useEffect, useState } from "react";
import { Container, Card, Alert, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import "../css/DetailNotification.css";
import { FaArrowLeft } from "react-icons/fa";
import { formatDateTime } from "../helpers/dateFormat";

const DetailNotification = () => {
  const { t, i18n } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();
  const [notification, setNotification] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchNotificationDetail = async () => {
      const token = localStorage.getItem("token");
      if (!token) {
        setError("User not authenticated.");
        setLoading(false);
        return;
      }

      try {
        const response = await axios.get(
          `${process.env.REACT_APP_APP_URL}/notifications/${id}`,
          {
            headers: {
              "Content-Type": "application/json",
              "X-Platform": process.env.REACT_APP_X_PLATFORM,
              "API-Key": process.env.REACT_APP_API_KEY,
              "X-API-Version": process.env.REACT_APP_X_API_VERSION,
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.data.success) {
          setNotification(response.data.data);
        } else {
          setError(response.data.message);
        }
      } catch (err) {
        setError(
          err.response?.data?.message || "Failed to fetch notification."
        );
      } finally {
        setLoading(false);
      }
    };

    fetchNotificationDetail();
  }, [id, i18n.language, t]);

  if (loading) {
    return (
      <Container className="detail-notification-container">
        <div className="detail-notification-shimmer">
          <div className="shimmer-card"></div>
          <div className="shimmer-title"></div>
          <div className="shimmer-text"></div>
          <div className="shimmer-footer"></div>
        </div>
      </Container>
    );
  }

  if (error) {
    return (
      <Container className="detail-notification-container">
        <Alert variant="danger" className="text-center my-5">
          {error}
        </Alert>
      </Container>
    );
  }

  return (
    <Container className="detail-notification-container">
      <Button className="back-button mb-3" onClick={() => navigate(-1)}>
        <FaArrowLeft /> {t("back")}
      </Button>
      <Card className="detail-notification-card">
        <Card.Body>
          <Card.Title>{notification.title}</Card.Title>
          <Card.Text>{notification.message}</Card.Text>
        </Card.Body>
        <Card.Footer>
          <small className="text-muted">
            {formatDateTime(notification.created_at)}
          </small>
        </Card.Footer>
      </Card>
    </Container>
  );
};

export default DetailNotification;
